var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13 12"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    transform: "translate(-267 -16)",
    stroke: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M278.607 17.393l-9.83 9.83m-.384-9.83l9.83 9.83",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))));
}

export default SvgClose;